import React from "react";

export default function OnePlatformSection() {
  const features = [
    {
      title: "Discoverability",
      desc: "Get found by innovators.",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="7" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      ),
    },
    {
      title: "RFQ Management",
      desc: "Receive relevant project opportunities.",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M7 3h7l4 4v14H7z" />
          <path d="M14 3v4h4" />
          <path d="M9 13h6M9 16.5h6M9 9.5h2" />
        </svg>
      ),
    },
    {
      title: "Quotations",
      desc: "Prepare and submit estimates digitally.",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="6" y="3" width="12" height="18" rx="2" />
          <path d="M9 7h6M9 11h6M9 15h4" />
          <path d="M9.5 18.5l1.2 1.2L13 17.5" />
        </svg>
      ),
    },
    {
      title: "Orders",
      desc: "Manage confirmed projects.",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 8l-9-5-9 5 9 5 9-5z" />
          <path d="M3 8v8l9 5 9-5V8" />
          <path d="M9.5 10.5l3 1.7 3-1.7" />
        </svg>
      ),
    },
    {
      title: "Team Management",
      desc: "Assign tasks to your employees.",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="9" cy="8" r="3.2" />
          <path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" />
          <circle cx="17" cy="8.5" r="2.4" />
          <path d="M15.5 14.2c2.2.4 3.8 2.1 3.8 4.5" />
        </svg>
      ),
    },
    {
      title: "Machine Utilisation",
      desc: "Increase productive machine hours.",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 15a8 8 0 0 1 16 0" />
          <path d="M12 15l4-6" />
          <circle cx="12" cy="15" r="1.2" />
        </svg>
      ),
    },
    {
      title: "Maintenance",
      desc: "Plan preventive maintenance.",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 12h4l2 7 4-14 2 7h8" />
        </svg>
      ),
    },
    {
      title: "Payments",
      desc: "Track invoices and payments.",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="6" width="20" height="13" rx="2" />
          <path d="M2 10h20" />
          <circle cx="16" cy="14.5" r="1.6" />
        </svg>
      ),
    },
    {
      title: "Analytics",
      desc: "Measure facility performance.",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
        </svg>
      ),
    },
  ];

  return (
    <section className="op-section">
      <style>{`
        .op-section {
          width: 100%;
          background: linear-gradient(180deg, #f7f9fd 0%, #eef1f8 100%);
          font-family: 'Inter', 'Segoe UI', sans-serif;
          box-sizing: border-box;
          padding: 72px 0;
        }
        .op-wrap {
          width: 100%;
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 32px;
          box-sizing: border-box;
          text-align: center;
        }
        .op-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          padding: 9px 18px;
          border-radius: 999px;
          background: #fdecd3;
          font-family: 'Sora', 'Segoe UI', sans-serif;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.12em;
          color: #0b1330;
        }
        .op-eyebrow-dot {
          width: 7px; height: 7px; border-radius: 50%;
          background: #f7941d; flex-shrink: 0;
        }
        .op-heading {
          font-family: 'Sora', 'Segoe UI', sans-serif;
          font-weight: 800;
          font-size: clamp(1.9rem, 4.2vw, 3rem);
          line-height: 1.2;
          letter-spacing: -0.02em;
          color: #0b1330;
          margin: 22px 0 0;
        }
        .op-accent { color: #f7941d; }

        .op-grid {
          margin-top: 48px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
          text-align: left;
        }
        .op-card {
          background: #ffffff;
          border: 1px solid #e7eaf3;
          border-radius: 18px;
          padding: 30px 28px;
          box-shadow: 0 20px 40px -30px rgba(11,19,48,0.15);
          box-sizing: border-box;
        }
        .op-icon-box {
          width: 52px;
          height: 52px;
          border-radius: 14px;
          background: #0b1330;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 22px;
        }
        .op-card-title {
          font-family: 'Sora', 'Segoe UI', sans-serif;
          font-weight: 700;
          font-size: 1.15rem;
          color: #0b1330;
          margin: 0;
        }
        .op-card-desc {
          margin-top: 10px;
          font-size: 0.96rem;
          line-height: 1.6;
          color: #6b7290;
        }

        /* Tablet: 2 columns */
        @media (max-width: 900px) {
          .op-grid { grid-template-columns: repeat(2, 1fr); }
        }

        /* Phones: 1 column */
        @media (max-width: 560px) {
          .op-section { padding: 48px 0; }
          .op-wrap { padding: 0 20px; }
          .op-grid { grid-template-columns: 1fr; margin-top: 32px; gap: 16px; }
          .op-card { padding: 24px 22px; }
        }
      `}</style>

      <div className="op-wrap">
        <span className="op-eyebrow">
          <span className="op-eyebrow-dot" />
          EVERYTHING IN ONE PLATFORM
        </span>

        <h2 className="op-heading">
          One platform to manage your
          <br />
          <span className="op-accent">entire facility business.</span>
        </h2>

        <div className="op-grid">
          {features.map((f, i) => (
            <div className="op-card" key={i}>
              <div className="op-icon-box">{f.icon}</div>
              <h3 className="op-card-title">{f.title}</h3>
              <p className="op-card-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}